import { createContext, useContext } from "react";
import {
  CategoryItemContextProps,
  CategoryItemWrapperProps,
} from "./contextTypes";

const CategoryItemContext = createContext<CategoryItemContextProps>(
  {} as CategoryItemContextProps
);

export const CategoryItemWrapper = ({
  categoryId,
  item,
  offer,
  index,
  addItem,
  logoUrl,
  isMenuView,
  children,
}: CategoryItemWrapperProps) => {
  return (
    <CategoryItemContext.Provider
      value={{ categoryId, item, offer, index, addItem, logoUrl, isMenuView }}
    >
      {children}
    </CategoryItemContext.Provider>
  );
};

export function useCategoryItemContext() {
  return useContext(CategoryItemContext);
}
